<template>
	<div class="mall-goods-container">
		<div class="mall-goods-detail">
			<!-- 返回按钮 -->
			<div class="back-bar">
				<el-button type="text" class="back-btn" @click="handleGoBack">
					<i class="el-icon-arrow-left"></i>
					返回
				</el-button>
			</div>

			<!-- 上方：商品信息 -->
			<div class="goods-info-section">
				<!-- 左侧：图片轮播 -->
				<div class="goods-gallery">
					<div class="main-image">
						<img :src="mainImage" :alt="goodsInfo.title" />
					</div>
				</div>

				<!-- 右侧：商品信息 -->
				<div class="goods-meta">
					<h1 class="goods-title">{{ goodsInfo.title }}</h1>
					<div class="goods-tags">
						<el-tag v-for="(tag, index) in goodsInfo.tags" :key="index" size="small" type="success" class="meta-tag">
							{{ tag }}
						</el-tag>
					</div>

					<div class="meta-list">
						<div class="meta-item">
							<span class="meta-label">商品价格：</span>
							<span class="meta-value">
								首页头条： 50000/年 30000/6个月 20000/3个月；宣传专栏：30000/年 20000/6个月 15000/3个月
							</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">所属类目：</span>
							<el-tag v-for="(cat, index) in goodsInfo.categories" :key="index" size="small" type="primary" class="meta-tag">
								{{ cat }}
							</el-tag>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货时间：</span>
							<span class="meta-value highlight-text">7个工作日</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货约定：</span>
							<span class="meta-value">购买商品服务后线上交付</span>
						</div>
					</div>

					<!-- 联系我们 -->
					<!-- <div class="contact-box">
						<div class="contact-left">
							<i class="el-icon-phone-outline contact-icon"></i>
							<div class="contact-info">
								<div class="contact-label">联系我们</div>
								<div class="contact-phone">{{ goodsInfo.contactPhone || 'xxx（请填写联系方式）' }}</div>
							</div>
						</div>
						<el-button type="text" class="copy-btn" @click="handleCopyPhone">
							<i class="el-icon-document-copy"></i>
							复制信息
						</el-button>
					</div> -->

					<!-- 操作按钮 -->
					<div class="action-btns">
						<el-button type="primary" size="medium" class="consult-btn" @click="handleConsult">立即购买</el-button>
						<el-button type="warning" size="medium" class="cart-btn" @click="handleAddCart">
							<i class="el-icon-shopping-cart-2"></i>
							加入购物车
						</el-button>
					</div>
				</div>
			</div>

			<!-- 下方：服务详情 -->
			<div class="service-detail-section">
				<div class="section-header">
					<div class="section-tab active">服务详情</div>
				</div>
				<div class="detail-content">
					<h3>服务介绍</h3>
					<p>
						本服务面向全省住建领域企业，于湖北建设信息网这一权威平台的首页、频道页等核心位置，开展专业且精准的企业品牌宣传投放工作。通过此服务，企业能够全方位、多维度地展示自身综合实力、业务范围以及经典项目案例，进而实现精准触达目标客户群体的目的。
					</p>
					<p>
						湖北建设信息网平台全面覆盖湖北省住建行业全产业链，具备强大的影响力与广泛的受众群体，无疑是住建领域企业进行品牌宣传与客户拓展的高效优质渠道。
					</p>
					<h3>展示内容</h3>
					<p>
						投放展示内容丰富多元，包含但不限于以下关键要素，企业可依据自身实际需求灵活进行配置
					</p>
					<p>
						企业宣传醒目展示：以突出、醒目的方式，对企业进行全方位宣传展示，确保企业形象深入人心。
					</p>
					<p>
						代表项目、活动：着重展示企业具有代表性的项目成果以及参与举办的重要活动，彰显企业在行业内的卓越成就与积极影响力。
					</p>
					<p>核心业务领域展示：精准呈现企业的核心业务领域，让目标客户清晰了解企业的专业优势与业务专长。</p>

					<h3>核心优势</h3>
					<p>
						精准触达：凭借住建行业垂直流量的特性，实现对目标客户群体的精准定位与高效触达，客户精准度极高，确保宣传资源的高效利用。
					</p>
					<p>
						数据可视：为企业提供实时的曝光量、浏览量数据监测服务，使宣传效果一目了然，企业能够随时掌握宣传动态，为后续决策提供有力数据支持。
					</p>
					<p>
						一对一服务：针对投放内容，我们提供专属的一对一服务，从宣传内容的编辑到发布，全程精心策划与执行，确保满足企业个性化的宣传需求。
					</p>
					<p>
						高性价比：投放至湖北建设信息网（住建全领域办事平台），我们以合理的价格提供优质的宣传服务，让企业的每一份投入都能获得超值回报，真正实现投有所值。
					</p>

					<h3>服务流程</h3>
					<p>下单购买：用户需在线上选购企业宣传服务，并详细填写欲宣传的相关信息，确认无误后完成订单支付操作。</p>
					<p>付款核对：财务部门将在 1 个工作日内对用户的支付状态进行认真核对，确保支付环节准确无误。</p>
					<p>信息核对：宣传部工作人员会在 2 个工作日内，仔细核对企业提供的信息以及宣传资料，保证信息的真实性、完整性与准确性。</p>
					<p>
						宣传发布：宣传部工作人员依据审核通过的信息与资料，精心编写符合平台风格与企业需求的宣传网站页面，确保宣传效果达到最佳。
					</p>
					<p>确认发货：商家根据宣传服务的实际发布情况，及时处理发货状态，向用户反馈服务进展。</p>
					<p>
						确认收货：宣传内容发布后，用户可在湖北建设信息网的对应位置查看相关宣传网站页面，在确认无误后，进行订单确认收货操作。
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 商城商品详情页
	 */
	export default {
		name: 'MallGoodsDetail',
		data() {
			return {
				activeImageIndex: 0,
				goodsInfo: {
					title: '企业宣传投放',
					images: [require('@/assets/mall/goods/goods-propaganda.png')],
					tags: ['品牌宣传营销服务'],
					categories: ['品牌宣传营销服务', '企业宣传定制'],
					price: '400元/年',
					contactPhone: '1859234781'
				}
			}
		},
		computed: {
			mainImage() {
				return this.goodsInfo.images[this.activeImageIndex] || this.goodsInfo.images[0]
			}
		},
		methods: {
			// 返回上一页
			handleGoBack() {
				this.$router.back()
			},
			// 切换主图
			handleSwitchImage(index) {
				this.activeImageIndex = index
			},
			// 复制联系方式
			handleCopyPhone() {
				const phone = this.goodsInfo.contactPhone || ''
				if (!phone) {
					this.$message.warning('暂无联系方式')
					return
				}
				if (navigator.clipboard) {
					navigator.clipboard
						.writeText(phone)
						.then(() => {
							this.$message.success('复制成功')
						})
						.catch(() => {
							this.$message.error('复制失败')
						})
				} else {
					// 降级方案
					const input = document.createElement('input')
					input.value = phone
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					this.$message.success('复制成功')
				}
			},
			// 立即咨询
			handleConsult() {
				// this.$message.info('咨询功能开发中')
				this.$router.push({
					path: '/mallStore/purchase',
					query: {
						displaySectorType: '1'
					}
				})
			},
			// 加入购物车
			handleAddCart() {
				// this.$message.success('已加入购物车')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/views/mall/goodsDetail/goodDetail.scss';
</style>
